module.exports = __webpack_public_path__ + "img/设置.23cb3045.svg";